export default __webpack_public_path__ + "src/docs/packages/cradle-boutique-hotel.pdf";